/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

export const getVSCodePluginParams = (params: [string, string][]) => {
  const vsCodePluginParams: { [key: string]: string } = {};

  params
    .filter(
      ([key]) =>
        key.toLowerCase() === 'profile' ||
        key.toLowerCase() === 'client_id' ||
        key.toLowerCase() === 'state' ||
        key.toLowerCase() === 'code_challenge' ||
        key.toLowerCase() === 'fidp'
    )
    .forEach(([key, value]) => {
      vsCodePluginParams[key] = value;
    });

  return vsCodePluginParams;
};
